import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Button, Dropdown, Loader} from 'semantic-ui-react';
import ReactDataSheet from 'react-datasheet';
import moment from 'moment';
import {hasAccessPermission} from '../../common/permissions/validations';
import {paths} from '../../common/dictionaries/urls';
import {resources, scopes} from '../../common/permissions/dictionary';
import {getNumericValue} from '../../common/util/fieldsValidation';
import {yearsOptions} from '../../common/constants/years';
import {Actions} from '../../common/actions';
import {
  parseData,
  parseHeaders,
  parseResults,
  getAllTotals,
  parseTotalValues,
} from '../utils';
import './itemBudget.scss';

class ItemBudget extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'dealer': '',
      'startDate': null,
      'year': moment().year(),
      'data': [
        {
          'type': 'REPUESTOS',
          'enero': 0,
          'febrero': 0,
          'marzo': 0,
          'abril': 0,
          'mayo': 0,
          'junio': 0,
          'julio': 0,
          'agosto': 0,
          'septiembre': 0,
          'octubre': 0,
          'noviembre': 0,
          'diciembre': 0,
        },
        {
          'type': 'ACCESORIOS',
          'enero': 1,
          'febrero': 2,
          'marzo': 3,
          'abril': 4,
          'mayo': 0,
          'junio': 0,
          'julio': 0,
          'agosto': 0,
          'septiembre': 0,
          'octubre': 0,
          'noviembre': 0,
          'diciembre': 0,
        },
        {
          'type': 'LUBRICANTES',
          'enero': 0,
          'febrero': 0,
          'marzo': 0,
          'abril': 0,
          'mayo': 0,
          'junio': 0,
          'julio': 0,
          'agosto': 0,
          'septiembre': 0,
          'octubre': 0,
          'noviembre': 0,
          'diciembre': 0,
        },
      ],
      'grid': [],
    };
  }

  componentDidMount() {
    if (
      !hasAccessPermission(
        this.props.permissions,
        resources.ItemBudget,
        scopes.Edit
      )
    ) {
      this.props.navigateTo(paths.AccessDenied);
    }
    this.props.deleteItemBudget();
    this.handleSearch();
  }

  componentDidUpdate(prevProps) {
    const {data} = this.props;
    if (prevProps.data !== data) {
      this.setState({
        'grid': this.parseArrToGridExcel(data),
      });
    }
  }

  parseArrToGridExcel(arr) {
    const {data} = this.state;
    const detail = Object.keys(data[0]);
    const header = parseHeaders(detail);
    const totals = getAllTotals(arr, detail);
    const result = parseResults(arr, detail);
    const totalsValues = parseTotalValues(arr, detail, totals);

    return [header, ...result, totalsValues];
  }

  handleSearch() {
    const {year} = this.state;
    this.props.getItemBudget(year);
  }

  handleSave() {
    const {grid, year} = this.state;
    const result = parseData(grid, year);
    this.props.saveItemBudget({'list': [...result]}, year);
  }

  handleChangeYear(value) {
    this.setState({'year': value}, () => this.handleSearch());
  }

  validateRawData(rawInput) {
    const inputValue = rawInput ? rawInput.replace(/[$,]/g, '') : 0;
    const parsedValue = +parseFloat(inputValue).toFixed(2);
    return !parsedValue || isNaN(parsedValue) || parsedValue < 0 ?
      0 :
      parsedValue;
  }

  getTotalsByType(grid, row) {
    let total = 0;
    for (let i = 1; i <= 12; i++) {
      total += this.validateRawData(grid[row][i].value);
    }
    return getNumericValue(total, 2);
  }

  getTotalsByMonth(grid, col) {
    let total = 0;
    for (let i = 1; i <= 3; i++) {
      total += this.validateRawData(grid[i][col].value);
    }
    return getNumericValue(total, 2);
  }

  updateCells(changes) {
    const COLUMN_TOTAL = 13;
    const ROW_TOTAL = 4;
    const grid = this.state.grid.map((row) => [...row]);
    changes.forEach(({row, col, value}) => {
      const oldValue = this.validateRawData(grid[row][col].value);
      const oldTotal = this.validateRawData(
        grid[ROW_TOTAL][COLUMN_TOTAL].value
      );

      const validatedValue = this.validateRawData(value);
      grid[row][col] = {
        ...grid[row][col],
        'value': getNumericValue(validatedValue, 2),
      };

      grid[row][COLUMN_TOTAL] = {
        ...grid[row][col],
        'value': this.getTotalsByType(grid, row),
        'readOnly': true,
      };
      grid[ROW_TOTAL][col] = {
        ...grid[row][col],
        'value': this.getTotalsByMonth(grid, col),
        'readOnly': true,
      };

      const totalUpdated = oldTotal - oldValue + validatedValue;
      grid[ROW_TOTAL][COLUMN_TOTAL] = {
        ...grid[ROW_TOTAL][COLUMN_TOTAL],
        'value': getNumericValue(totalUpdated, 2),
        'readOnly': true,
      };
    });
    this.setState({grid});
  }

  renderHeader() {
    const {loading, saving} = this.props;
    const {year} = this.state;

    return (
      <Card raised fluid>
        <div className='title-bar'>
          <div className='title'>
            <h2>Mantenimientos de Presupuesto</h2>
            <div className='title-bar-actions'>
              <h4>Selección de año</h4>
              <Dropdown
                selection
                search
                value={year}
                options={yearsOptions}
                disabled={loading || saving}
                label='Seleccionar año'
                onChange={(event, {value}) => this.handleChangeYear(value)}
                placeholder='Seleccionar año'
              />

              <Button
                secondary
                disabled={loading || saving}
                onClick={() => this.handleSearch()}
              >
                Consultar
              </Button>
              <Button
                primary
                disabled={loading || saving}
                onClick={() => this.handleSave()}
              >
                Guardar
              </Button>
            </div>
          </div>
        </div>
      </Card>
    );
  }

  renderSheet() {
    const {loading} = this.props;
    const {grid} = this.state;
    if (loading) {
      return (
        <Card raised fluid>
          <Card.Content>
            <Loader active inline='centered' />
          </Card.Content>
        </Card>
      );
    }

    return (
      <Card raised fluid className='maintenance-parts-budget-data-sheet'>
        <div className='horizontal-scroll'>
          <ReactDataSheet
            valueRenderer={(cell) => cell.value}
            data={grid}
            onCellsChanged={(changes) => this.updateCells(changes)}
          />
        </div>
      </Card>
    );
  }

  render() {
    return (
      <div className='maintain-sale-forecast-container'>
        {this.renderHeader()}
        {this.renderSheet()}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'permissions': state.session.permissions,
    'data': state.itemBudget.itemBudget,
    'loading': state.itemBudget.loading,
    'saving': state.itemBudget.saving,
  };
};

const {getItemBudget, saveItemBudget, deleteItemBudget, navigateTo} = Actions;

export default connect(mapStateToProps, {
  getItemBudget,
  saveItemBudget,
  deleteItemBudget,
  navigateTo,
})(ItemBudget);
